import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  clearStorageByKey(key: string) {
    localStorage.removeItem(key);
  }

  clearAll() {
    localStorage.clear();
  }

  setKeyValue(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getValueByKey(key: string) {
    return JSON.parse(localStorage.getItem(key));
  }
}
